import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Trabajas, pagas cuentas… y aun así sientes que el dinero desaparece.', 'Te prometes “este mes sí me organizo” y vuelve a pasar lo mismo.', 'Tienes tarjeta(s) con saldo, haces pagos mínimos y piensas: “¿cómo salgo de aquí?”', 'Te estresa abrir el banco, te da ansiedad revisar el mail por si llegó otra factura.', 'Quieres ahorrar, pero siempre hay algo: niños, carro, comida, imprevistos.'];
  return <section className="py-20 bg-navy-800/50 relative" data-id="element-167">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-168">
        <FadeIn data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-170">
            ¿Te suena familiar?
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-16" data-id="element-171">
          {points.map((point, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-172">
              <div className="glass-card flex items-start gap-4 group" data-id="element-173">
                <div className="mt-1 bg-gold-500/10 p-2 rounded-full text-gold-500 group-hover:bg-gold-500 group-hover:text-navy-900 transition-colors" data-id="element-174">
                  <AlertCircleIcon className="w-5 h-5" data-id="element-175" />
                </div>
                <p className="text-lg text-slate-300 leading-relaxed" data-id="element-176">
                  {point}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-177">
          <div className="text-center bg-teal-900/30 border border-teal-900/50 rounded-xl p-8 relative overflow-hidden" data-id="element-178">
            <div className="absolute top-0 left-0 w-1 h-full bg-gold-500" data-id="element-179" />
            <p className="text-xl md:text-2xl text-white font-medium mb-4" data-id="element-180">
              Si estás asintiendo con la cabeza, no es que "seas mala con el
              dinero".
            </p>
            <p className="text-lg text-slate-300" data-id="element-181">
              Es que nunca te dieron un sistema simple que funcione con la vida
              real.
            </p>
            <p className="text-xl text-gold-400 font-bold mt-6" data-id="element-182">
              Y hoy eso cambia.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}